import { Buffer } from "buffer";
import service from "@ipru-common/services/service";

const Blowfish = require("egoroof-blowfish");

const BF_KEY = ["!t@a6@($%(", "DIGI1234", "Mt%sOmD17r-pqZN", "!i@*6@($%("];
const BF_MODE = Blowfish.MODE.EBC;
const BF_PADDING = Blowfish.PADDING.PKCS5;
const BF_TYPE = Blowfish.TYPE.STRING;

const BF_OG = new Blowfish(BF_KEY[0], BF_MODE, BF_PADDING);
const BF_DG = new Blowfish(BF_KEY[1], BF_MODE, BF_PADDING);
const BF_DEP = new Blowfish(BF_KEY[2], BF_MODE, BF_PADDING);
const BF_GRPEMP = new Blowfish(BF_KEY[3], BF_MODE, BF_PADDING);

export const NDNC_DISCLAIMER_FULL =
  "By submitting my details, I override my NCPR registration and authorize ICICI Life Insurance Company Limited, its third parties and its representatives to contact me through call, RCS, WhatsApp, E-Mail or other modes. I further consent to permit ICICI Life Insurance Company Limited to process and share my information with its third parties and its representatives for (i) contacting me (ii) evaluating and processing this proposal (iii) risk assessment (iv) conducting surveys and feedback in relation to the Company’s services/ offerings (v) enhancing its products/ services and undertaking research and analysis.";
export const NDNC_DISCLAIMER_TRUNCATED =
  "By submitting my details, I override my NCPR registration and authorize ICICI Life Insurance Company Limited, its third parties and its representatives to contact me through call, RCS, WhatsApp, E-Mail or other modes. I further consent to permit ICICI Life Insurance Company Limited to process and share my information with its third parties and its representatives for (i) contacting me (ii) evaluating and processing this proposal (iii) risk assessment";

const BlowFishReact = (encrypt, key, data) => {
  var BF =
    key === "DIGI"
      ? BF_DG
      : key === "DEP"
        ? BF_DEP
        : key === "GRPEMP"
          ? BF_GRPEMP
          : BF_OG;
  if (encrypt) {
    var encryptedData = BF.encode(JSON.stringify(data));
    encryptedData = Buffer.from(encryptedData).toString("base64");
    return encryptedData;
  } else {
    var dataBuffered = Buffer.from(data, "base64");
    var decryptedData = BF.decode(dataBuffered, BF_TYPE);
    return decryptedData;
  }
};

const numDifferentiation = (val, point) => {
  if (val >= 10000000) {
    val = (val / 10000000).toFixed(point);
    val = parseFloat(val) + " Crore";
  } else if (val >= 100000) {
    val = (val / 100000).toFixed(point);
    val = parseFloat(val) + " Lakh";
  } else {
    val = parseFloat(val).toFixed(0);
    val = (val + "").replace(/(\d)(?=(\d\d)+\d$)/g, "$1,");
  }
  return val;
};

var UserDataJSON = window.UserDataJSON;
var clientId = window.clientId;
var UserInput = window.UserInput;
var PrefillUserJson = window.PrefillUserJson;

var fillLead_flag = window.fillLead_flag;
var gamoogaEvent = window.gamoogaEvent;
var Enc_UserData = window.Enc_UserData;
var isDate = window.isDate;
var Glb_UID = window.Glb_UID;

// functions to add and remove commas

const addCommas = (nStr) => {
  return nStr.toString().replace(/(\d+?)(?=(\d\d)+(\d)(?!\d))(\.\d+)?/g, "$1,");
};

const removeCommas = (numWidCommas) => {
  return numWidCommas.replace(/[,]/g, "");
};

const downloadFile = (url, fileName) => {
  var element = document.createElement("a");
  element.setAttribute("href", url);
  element.setAttribute("download", fileName);
  element.style.display = "none";
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

const numConvert = (n) => {
  let ord = ["st", "nd", "rd"];
  let exceptions = [11, 12, 13];
  let nth =
    ord[(n % 10) - 1] == undefined || exceptions.includes(n % 100)
      ? "th"
      : ord[(n % 10) - 1];
  return n + nth;
};

const scrollToClass = (target, type = "smooth") => {
  var element = document.getElementsByClassName(target)[0];
  console.info("ScrollToClass :", element);
  element.scrollIntoView({ behavior: type, block: "center" });
};

const ScrollToSection = (ScrollTo, yOffset) => {
  if (ScrollTo) {
    try {
      const element = document.getElementsByClassName(ScrollTo)[0];
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    } catch (error) {
      console.log(error);
    }
  }
};

const scrollToClassHorizon = (target) => {
  var element = document.querySelector(`.${target}`);
  console.info("scrollToClassHorizon :", element);
  element.scrollIntoView({
    behavior: "smooth",
    block: "center",
    inline: "center",
  });
};

const handleClassClick = (target) => {
  var element = document.querySelector(`.${target}`);
  element.click();
};

const scrollPatch = (type) => {
  setTimeout(() => {
    try {
      var contentWrapper = document.getElementsByTagName("body")[0];
      if (contentWrapper.hasAttribute("style")) {
        contentWrapper.style.overflow = type;
      }
    } catch {}
  }, 1000);
};

const scrollToId = (target) => {
  var element = document.getElementById(target);
  element.scrollIntoView({ behavior: "smooth", block: "center" });
};

const fundFiltered = (arr1) => {
  console.log("filtering part", arr1);
  const key = "LAfundCode";
  const uniqueArray = Array.from(new Set(arr1.map((item) => item[key]))).map(
    (id) => {
      return arr1.find((item) => item[key] === id);
    },
  );
  console.log(uniqueArray);
  return uniqueArray;
};

const mergeTwoObj = (array1, array2, mergeKey) => {
  let resultArray = array1.map((x) => ({
    ...x,
    ...array2.find((y) => y[mergeKey] === x[mergeKey]),
  }));
  resultArray = fundFiltered(resultArray); // filtering out extra objs.
  return resultArray;
};

const mergeByProperty = async (origArr, updatingArr, mergeKey) => {
  var value = await origArr.map(
    function (a) {
      return this[a[mergeKey]] || a;
    },
    updatingArr.reduce(function (r, a) {
      r[a[mergeKey]] = a;
      return r;
    }, Object.create(null)),
  );
  value = await mergeTwoObj(origArr, value, mergeKey);
  return value;
};

const getValueFromJsonObj = (object, keyVal, returnKey) => {
  for (var key in object) {
    if (key == keyVal) return object[keyVal][returnKey];
  }
  return "";
};

async function CreateReactCookie() {
  var UserInput = window.UserInput;
  var cookieTS = new Date().getTime();
  try {
    for (var key in UserInput) {
      if (UserInput[key] != undefined) {
        PrefillUserJson[key] = UserInput[key].toString();
      }
    }
    if (isDate(UserInput.dob)) {
      var d = new Date();
      d.setTime(d.getTime() + 91 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var UserDataJSON = (Enc_UserData = "");
      var birthdateorig = UserInput.dob.split("/");
      var currentyear = new Date().getFullYear();
      var date2 = new Date();
      var finaldob = new Date(
        birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear,
      );
      // var finaldob = new Date(birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear)
      var timeDiff = finaldob.getTime() - date2.getTime();
      var daysdiff = Math.ceil(timeDiff / (1000 * 24 * 3600));
      try {
        PrefillUserJson.GAid = document.cookie
          .split("GA_VisitorID=")[1]
          .split(";")[0];
      } catch {
        PrefillUserJson.GAid = "";
      }
      PrefillUserJson.PageName = "ULIP Plan Signature Calculator";
      PrefillUserJson.UID = Glb_UID;
      PrefillUserJson.timestamp = cookieTS;
      // PrefillUserJson.lifeCover2 = setValFW(PrefillUserJson.lifeCover);
      // Enc_UserData = JSON.stringify(PrefillUserJson) Removed Strinify for cookie issue.
      Enc_UserData = PrefillUserJson;
      console.info("PrefillUserJson : ", Enc_UserData);

      var UserDataJSON = await BlowFishReact(true, "", Enc_UserData);
      document.cookie =
        "SIGNATURECookie=" + UserDataJSON + ";" + expires + ";path=/";
      console.log("document.cookie", document.cookie);
      if (date2.getMonth() == 10 || date2.getMonth() == 11) {
        if (finaldob.getMonth() >= date2.getMonth()) {
        } else {
          currentyear = currentyear + 1;
          finaldob = new Date(
            birthdateorig[1] + "/" + birthdateorig[0] + "/" + currentyear,
          );
        }
      }
      if (daysdiff > 0 && daysdiff <= 60) {
        localStorage.setItem("BirthdayUsecase", "true");
      } else {
        localStorage.setItem("BirthdayUsecase", "false");
      }
    }
  } catch (e) {
    console.log("Error: CreateCookie Function - " + e);
  }

  var UserDataJSON1 =
    "SigproductId=UW3&dob=" +
    UserInput.dob +
    "&timestamp=" +
    cookieTS +
    "&ends=" +
    this;
  UserDataJSON1 = await BlowFishReact(true, "", UserDataJSON1);
  console.info("UserDataJSON1 :", UserDataJSON1);
  document.cookie =
    "encryptedCookie=" + UserDataJSON1 + ";" + expires + ";path=/";

  if (typeof setStorageBoi == "function") {
    setStorageBoi(UserInput, "productInfoSIGNATURE");
  }
}
window.CreateReactCookie = CreateReactCookie;
const getCookieBoi = async (cname) => {
  try {
    var name = cname + "=";
    var data = document.cookie.split("encryptedCookie=");
    var UserDataJSON = await BlowFishReact(false, "", data[1]);
    UserDataJSON = UserDataJSON.replace('"', "");
    UserDataJSON = UserDataJSON.split("&ends")[0];
    var ca = UserDataJSON.split("&");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  } catch (err) {
    //console.log("personalization tag is not available. "+err);
  }
};

const getStorageBoi = async (key, count = 0) => {
  count = count + 1;
  if (count > 5) {
    return false;
  }
  try {
    var value = await JSON.parse(
      window.$.jCryptionDIGI.decrypt(localStorage.getItem(key), "encrypt"),
    );
    console.info("getStorageBoi Value :", window.UserInput.dob, value.dob);
    if (window.UserInput.dob === value.dob) {
      console.log("value matched");
      window.localDobFlag = true;
      return value;
    }
  } catch (e) {
    console.log(
      "getStorageBoi: Error reading key [" +
        key +
        "] from localStorage: " +
        JSON.stringify(e),
    );
    return new Promise((res) =>
      setTimeout(() => res(getStorageBoi(key, count)), 1000),
    );
  }
};

const getReactStorageBoi = async (key) => {
  // Prodigy Funtion
  try {
    var tempStorage = localStorage.getItem(key + "_R");
    var SyncDOB = await BlowFishReact(false, "DEP", tempStorage);
    return JSON.parse(SyncDOB);
  } catch {
    return false;
  }
};

const setStorageBoi = async (data, key, count = 0) => {
  console.info("Set Storage :", data);
  count = count + 1;
  if (count > 5) {
    return false;
  }
  if (count === 1) {
    var SyncDOB = await BlowFishReact(true, "DEP", data);
    localStorage.setItem(key + "_R", SyncDOB);
  }
  try {
    var dataStr = JSON.stringify(data);
    var encryptedData = window.$.jCryptionDIGI.encrypt(dataStr, "encrypt");
    localStorage.setItem(key, encryptedData);
    console.info("setStorageBoi Passed :", data, key, count);
  } catch (e) {
    console.log(
      "setStorageBoi: Error setting key [" +
        key +
        "] in localStorage: " +
        JSON.stringify(e),
    );
    return new Promise((res) =>
      setTimeout(() => res(setStorageBoi(data, key, count)), 1000),
    );
  }
  return true;
};

const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};

const capitalize = (str) => {
  try {
    return str[0].toUpperCase() + str.slice(1);
  } catch {
    return str;
  }
};

function debounce(fn, wait = 200) {
  let timeout;
  return function () {
    let context = this;
    let args = arguments;

    clearTimeout(timeout);

    timeout = setTimeout(function () {
      fn.apply(context, args);
    }, wait);
  };
}

const ToggleCheckboxError = (formRef, formName, validationFlag) => {
  var element = document
    .querySelector(`#${formName}`)
    .closest(".CheckboxGroup").classList;

  formRef.setFields([
    {
      name: formName,
      errors: validationFlag ? [" "] : [],
    },
  ]);

  if (validationFlag) {
    if (!element.contains("ErrorExist")) {
      element.add("ErrorExist");
    }
  } else {
    if (element.contains("ErrorExist")) {
      element.remove("ErrorExist");
    }
  }
};

//Masking Common Function
const mask = (value) => {
  const data = value.split("");
  var len = data.length;
  var newarr = [];
  for (var i = 0; i <= len - 1; i++) {
    if (i == 0 || i == 1 || i == len - 1) {
      newarr[i] = data[i];
    } else {
      newarr[i] = "X";
    }
  }
  const response = newarr.toString().replace(/,/g, "");
  return response;
};

const maskData = (value) => {
  const dob = value.split("/");
  const data =
    dob[0] +
    "/XX" +
    "/XXX" +
    dob[2].substring(dob[2].length - 1, dob[2].length);
  return data;
};

const maskMobile = (value) => {
  const mob = value.toString().split("");
  const maskedmob = mob[0] + mob[1] + "XXXXXXX" + mob[9];
  return maskedmob;
};

const maskEmail = (value) => {
  const mail = value.split("@");
  const provider = mail[1].split(".");
  const name = mask(mail[0]);
  const mailprovider0 = mask(provider[0]);
  const mailprovider1 = mask(provider[1]);
  console.log(name, "@", provider);
  const maskedMail = name + "@" + mailprovider0 + "." + mailprovider1;
  return maskedMail.toLowerCase();
};

const HideLandingLoader = () => {
  document.querySelector(".Spinner_Background").style.display = "none";
  var spinner = document.querySelector("body").classList;
  if (spinner.contains("Spinner_Default")) spinner.remove("Spinner_Default");
};

const InjectCustomAppForm = () => {
  var randomTS = new Date().getTime();
  var s = document.createElement("script");
  s.src = process.env.REACT_APP_APPFORM + randomTS; // Prod
  document.body.appendChild(s);
};

const AppFormFunctions = (flag) => {
  var isResume = flag === 1;
  console.warn("Looping Ropes...");
  // console.warn("areDependencyLoaded :", isResume, window.UserDataJSON, window.PopulateAppForm, window.Messageorder_cust, window.configFieldsInfo)
  if (
    typeof window.UserDataJSON === "object" &&
    typeof window.PopulateAppForm === "function" &&
    typeof window.Messageorder_cust === "object" &&
    typeof window.configFieldsInfo === "object" &&
    typeof window.Service_OCR === "function"
  ) {
    return true;
  } else {
    return false;
  }
};

const getSHA256Hash = async (input) => {
  const textAsBuffer = new TextEncoder().encode(input);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", textAsBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray
    .map((item) => item.toString(16).padStart(2, "0"))
    .join("");
  return hash;
};
//Middleware For CKYC
window.UserSession = {
  SessionToken: "",
  JwtToken: "",
};
async function generateJWTToken(iSUat, isMiddleware = false) {
  try {
    const headers = new Headers();
    const authValue = iSUat
      ? "RFFGdVBCV3BpdXRjQmlmb3R2aXl5bVFIaVM3RXAyM1Q6bURYa05iOXd3ZmZQVGNGTQ=="
      : isMiddleware
        ? "bkdLUHNpWklCdU9LbWhvODFzTE1BY2Vva3EzbUJRVks6enBaUnZSd3h5ekR4NUc4aw=="
        : "aWlqVW5HVWZWYlNLOUtWVHNxVFltUE1IeEZZWnQ2aFQ6RVBLelZaTm5JU2tXN2ZlMQ==";
    headers.append("Authorization", `Basic ${authValue}`);
    var payloadOption = {
      method: "POST",
      credentials: "include",
      headers: headers,
    };
    const jwtReq = iSUat
      ? await fetch("https://api-dex.icicilife.com/v1/oauth/jwt", payloadOption)
      : await fetch("https://api.icicilife.com/v1/oauth/jwt", payloadOption);
    const jwtRes = await jwtReq.json();
    // console.log(jwtRes)
    const token = jwtRes.token;
    window.UserSession["JwtToken"] = token;
    return token;
  } catch (e) {
    // console.log("Error Occured while creating JWT Token: ", e)
    return e;
  }
}
async function generateSessionToken(tokenString, iSUat) {
  try {
    var headers = new Headers();
    headers.append("Authorization", `Bearer ${tokenString}`);
    headers.append("Content-Type", "application/json");
    var rawBody = JSON.stringify({ appCode: "BOLTECH" });
    const payloadOption = {
      method: "POST",
      headers: headers,
      body: rawBody,
      credentials: "include",
    };
    const sessionRes = iSUat
      ? await fetch(
          "https://api-dex.icicilife.com/v1/bol/middleware/generate/token",
          payloadOption,
        )
      : await fetch(
          "https://api.icicilife.com/v1/bol/middleware/generate/token",
          payloadOption,
        );
    // const sessionRes = await fetch("https://api.icicilife.com/bol/middleware/generate/token", payloadOption)
    if (sessionRes.status === 200) {
      var sessionData = await sessionRes.json();
      const { status, token } = sessionData;
      // console.log(status)
      window.UserSession["SessionToken"] = token;
      return [token];
    } else {
      // console.log("Invalid response from server")
      return [null];
    }
  } catch (e) {
    console.log("Error Occurred on Generating Session Token: ", e);
    return 0;
  }
}

//Manage Timneout
var startTime = new Date();
var timeoutLength = 1800000;
var startTimeEpoch = startTime.valueOf();
let iSUat = false;
let jwtToken = "";
let sessionToken = "";
let HitOnce = true;
//Check every 30 Mins for Idle
var interval = setInterval(checkTimeout, 1800000);
async function checkTimeout() {
  return;
  var currentTime = new Date();
  var currentTimeEpoch = currentTime.valueOf();
  console.log(
    currentTime,
    currentTimeEpoch,
    startTime,
    startTimeEpoch,
    currentTimeEpoch > startTimeEpoch + timeoutLength,
  );
  if (currentTimeEpoch > startTimeEpoch + timeoutLength) {
    clearInterval(interval);
    console.log("Your current Session is over. Recalling Middleware.");
    //Rehit Session every 30 Mins
    jwtToken = await generateJWTToken(iSUat, true);
    sessionToken = await generateSessionToken(jwtToken, iSUat);
  }
}

async function callMiddlewareAPI(
  apiName,
  body,
  iSUat = false,
  custom_headers = { "Content-Type": "application/json" },
  stringifyBody = false,
  method = "POST",
  queryParams = null,
) {
  if (!custom_headers["Content-Type"]) {
    custom_headers["Content-Type"] = "application/json";
  }
  try {
    if (stringifyBody) body = JSON.stringify(body);
    const response = await service({
      apiName: apiName,
      method: method,
      data: body,
      queryParams: queryParams,
      headers: custom_headers || {},
      directResponse: true,
    });
    return response.data || response;
  } catch (e) {
    console.log("Error Occured on Calling API: ", e);
    throw e;
  }
}
window.callMiddlewareAPI = callMiddlewareAPI;
window.isCallMiddlewareApiChanged = true;

const maskDetail = (value) => {
  if (value.includes("@")) {
    const [mail, domain] = value.split("@");
    const visible = mail.slice(-2);
    const masked = "X".repeat(Math.max(0, mail.length - 2));
    return masked + visible + "@" + domain;
  }

  if (value.includes("/")) {
    const parts = value.split("/");
    if (parts.length !== 3) return value;

    const year = parts[2];
    return `XX/XX/${year}`;
  }
  return value.replace(/.(?=.{4})/g, "X");
};

export {
  numDifferentiation,
  CreateReactCookie,
  BlowFishReact,
  removeCommas,
  addCommas,
  downloadFile,
  numConvert,
  AppFormFunctions,
  scrollPatch,
  scrollToClass,
  scrollToClassHorizon,
  handleClassClick,
  scrollToId,
  mergeTwoObj,
  mergeByProperty,
  getValueFromJsonObj,
  getCookieBoi,
  getReactStorageBoi,
  getStorageBoi,
  setStorageBoi,
  isJson,
  capitalize,
  ScrollToSection,
  debounce,
  ToggleCheckboxError,
  maskData,
  maskEmail,
  maskMobile,
  InjectCustomAppForm,
  HideLandingLoader,
  getSHA256Hash,
  generateSessionToken,
  generateJWTToken,
  callMiddlewareAPI,
  maskDetail,
};
